<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import MediaCreate from './../../../MediaManager/views/Create.vue'
	import Multiselect from 'vue-multiselect'
	import CategorySort from './Sort'
	import Slug from './Slug'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'media-create': MediaCreate,
			'multiselect': Multiselect,
			'category-sort': CategorySort,
			'slug': Slug,
		},
		watch: {
			'item.title'() {
				this.item.slug = this.$options.filters.slugify(this.item.title)
			},
			'item.slug'() {
				this.checkSlug()
			},
			'item.lang_id'() {
				this.getCategories()
			},
			category() {
				if(this.category) {
					this.item.parent_id = this.category.id
				} else {
					this.item.parent_id = null
				}
			}
		},
		data () {
			return {
				languages: null,
				statuses: null,
				roles: null,
				categories: null,

				category: null,

				slug_in_use: false,

				item: null,

				id: this.$route.params.id,

				loading: false,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: null,
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 1,
				},

				editor: true,
			}
		},
		created() {
			this.init()
		},
		mounted() {
			[].slice.call(document.querySelectorAll('.sttabs')).forEach(function(el) {
				new CBPFWTabs(el);
			})
		},
		methods: {
			init() {
				this.getData()
				this.getLanguages()
				this.getStatuses()
				this.getRoles()
			},
			reload() {
				if(this.$refs.mediacreate) {
					this.$refs.mediacreate.close()
				}
				this.getData()
			},
			getData() {
				this.$http.get('admin/cms/categories/' + this.id + '/edit')
					.then(response => {
						this.item = response.body
						this.getCategories()
						this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/cms/categories/' + this.item.id
					})
			},
			getLanguages: function() {
				this.$http.get('languages')
					.then(response => {
						this.languages = response.body
					})
			},
			getStatuses: function() {
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getRoles: function() {
				this.$http.get('admin/roles')
					.then(response => {
						this.roles = response.body
					})
			},
			getCategories: function() {
				if(this.item.parent) {
					this.category = this.item.parent
				}
				this.categories = null
				var data = {
					lang_id: this.item.lang_id,
					id: this.item.id,
				}
				this.$http.post('admin/cms/categories/get', data)
					.then(response => {
						this.categories = response.body
					})
			},
			checkSlug() {
				if(this.item.slug) {
					this.loading = true
					var data = {
						id: this.item.id,
						lang_id: this.item.lang_id,
						slug: this.item.slug,
					}
					this.$http.post('admin/cms/categories/check/slug', data)
						.then(response => {
							var in_use = response.body
							this.slug_in_use = in_use > 0
							this.loading = false
						})
				} else {
					this.slug_in_use = false
				}
			},
			validate() {
				var that = this
				if(this.slug_in_use) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			update () {
				if(!this.loading) {
					if(!this.slug_in_use) {
						var loadingTop = Ladda.create(this.$refs.btnStoreTop)
						var loadingBottom = Ladda.create(this.$refs.btnStoreBottom)
						loadingTop.start()
						loadingBottom.start()
						this.$http.put('admin/cms/categories/' + this.item.id, this.item)
						.then(response => {
							loadingTop.stop()
							loadingBottom.stop()
							swal({
								title: response.body.title,
								text: response.body.text,
								type: response.body.type,
							})
						}).catch(function(response) {
							console.log(response)
							loadingTop.stop()
							loadingBottom.stop()
							if(response.status == 409) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}
						})
					}
				}
			},
			destroyCover() {
				var media = this.item.cover
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete(process.env.ROOT + '/api/' + that.$lang.getLang() + '/admin/media/' + media.id + '/destroy')
							.then(response => {
								that.$set(that.item, 'cover', null)
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			onEditorChange({ quill, html, text }) {
				if(html.length > 255) {
					quill.deleteText(255, quill.getLength());
				}
			},
			stripHTMLDescription() {
				var html = this.item.description
				var div = document.createElement("div")
				div.innerHTML = html
				var text = div.textContent || div.innerText || ""
				this.item.description = text
			},
			slugInUse(slug_in_use) {
				this.slug_in_use = slug_in_use
			},
			changeLoading(loading) {
				this.loading = loading
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/cms/categories/views/Edit.vue